import React, { useState } from 'react';
import { Grid, Button, FormControlLabel, Checkbox, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';

import TimeSlot from './TimeSlot';

/**
 * Props for the DaySchedule component
 */
interface DayScheduleProps {
    label: string;
    isChecked?: boolean;
    getSource: (source: string) => string;
}

/**
 * A component that displays a day's schedule with a checkbox and time slots
 * Allows adding and removing time slots dynamically
 */
const DaySchedule: React.FC<DayScheduleProps> = ({ label, getSource, isChecked }) => {
    const [timeSlots, setTimeSlots] = useState([{ from: '', to: '' }]);

    const addTimeSlot = () => {
        setTimeSlots([...timeSlots, { from: '', to: '' }]);
    };

    const removeTimeSlot = (index: number) => {
        setTimeSlots(timeSlots.filter((_, i) => i !== index));
    };

    return (
        <Grid container direction="column" spacing={2}>
            <Grid item>
                <FormControlLabel control={<Checkbox />} label={label} checked={isChecked} />
            </Grid>
            {timeSlots.map((slot, index) => (
                <Grid item key={index} container justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <Typography>Години роботи:</Typography>
                    </Grid>
                    <Grid item>
                        <TimeSlot index={index} getSource={getSource} />
                    </Grid>
                    <Grid item>
                        {index === timeSlots.length - 1 ? (
                            <Button onClick={addTimeSlot} variant="outlined" startIcon={<AddCircleOutlineIcon />}>
                                Інтервал
                            </Button>
                        ) : (
                            <Button onClick={() => removeTimeSlot(index)} variant="outlined" startIcon={<DeleteIcon />}>
                                Видалити
                            </Button>
                        )}
                    </Grid>
                </Grid>
            ))}
        </Grid>
    );
};

export default DaySchedule;
